// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%2714%27 viewBox=%270 0 14 14%27%3E%3Cg stroke=%27%23333333%27 stroke-width=%271.35%27 stroke-linecap=%27round%27%3E%3Cline x1=%272%27 y1=%2711%27 x2=%275%27 y2=%2714%27/%3E%3Cline x1=%272%27 y1=%277.5%27 x2=%278.5%27 y2=%2714%27/%3E%3Cline x1=%272%27 y1=%274%27 x2=%2712%27 y2=%2714%27/%3E%3Cline x1=%272%27 y1=%270.5%27 x2=%2714%27 y2=%2712.5%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%2714%27 viewBox=%270 0 14 14%27%3E%3Cg stroke=%27%23111111%27 stroke-width=%271.35%27 stroke-linecap=%27round%27%3E%3Cline x1=%272%27 y1=%2711%27 x2=%275%27 y2=%2714%27/%3E%3Cline x1=%272%27 y1=%277.5%27 x2=%278.5%27 y2=%2714%27/%3E%3Cline x1=%272%27 y1=%274%27 x2=%2712%27 y2=%2714%27/%3E%3Cline x1=%272%27 y1=%270.5%27 x2=%2714%27 y2=%2712.5%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* OpenSeadragon viewer styles. */

/* Single canvas for tiled-level camera fields, composited above the OSD canvas */
.morphle-tiled-fields-canvas {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 2;
}

/* Keep OSD control docks (navigator etc.) above overlays drawn inside the container */
.openseadragon-container > div:not(.openseadragon-canvas) {
    z-index: 100;
}

/* Navigator (minimap): top-right, below the toggle button. Offsets mirror NAVIGATOR_LAYOUT in viewerConfig.js. */
.openseadragon-container .navigator {
    /* Absolute so a width/height resize is not fought by OSD's relative dock layout */
    position: absolute !important;
    top: 60px !important;
    right: 20px !important;
    bottom: auto !important;
    left: auto !important;
    background-color: rgba(255, 255, 255, 0.55) !important;
    border: 2px solid #333 !important;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    overflow: hidden !important;
    box-sizing: border-box !important;
}

/* Seen-area heatmap, drawn inside the navigator under its display-region box */
.osd-seen-area-canvas {
    position: absolute;
    left: 0;
    top: 0;
    pointer-events: none;
}

.openseadragon-container .navigator-scroll-handle,
.openseadragon-container .displayregion {
    border: 2px solid rgba(0, 128, 255, 0.5) !important;
}

/* Diagonal resize grip at the navigator's bottom-left corner */
.osd-navigator-resize-handle {
    position: absolute !important;
    width: 14px !important;
    height: 14px !important;
    z-index: 10000 !important;
    cursor: nesw-resize !important;
    box-sizing: border-box;
    pointer-events: auto !important;
    border: none;
    background-color: transparent;
    box-shadow: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 14px 14px;
    background-position: left bottom;
    background-repeat: no-repeat;
    opacity: 0.75;
}

.osd-navigator-resize-handle:hover {
    opacity: 1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

/* Scale bar under the right-bottom controls (ScaleBarOSD) */
.osd-scale-bar-pro {
    pointer-events: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    background-color: rgba(255, 255, 255, 0.85);
    padding: 8px 12px;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    margin-top: 6px;
    margin-right: 6px;
}

.osd-scale-bar-pro__ruler {
    display: flex;
    align-items: center;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.4));
}

/* Width is set inline */
.osd-scale-bar-pro__line {
    height: 2px;
    background-color: #333;
    transition: width 0.15s ease-out;
    min-width: 30px;
}

.osd-scale-bar-pro__cap {
    width: 2px;
    height: 10px;
    background-color: #333;
    border-radius: 1px 1px 0 0;
}

.osd-scale-bar-pro__label {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.02em;
    color: #333;
    padding-left: 2px;
    -webkit-user-select: none;
            user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/component/gammaviewer/openseadragon/styles.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC,iFAAiF;AACjF;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,UAAU;AACd;;AAEA,sFAAsF;AACtF;IACI,YAAY;AAChB;;AAEA,iHAAiH;AACjH;IACI,kFAAkF;IAClF,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,sDAAsD;IACtD,iCAAiC;IACjC,kBAAkB;IAClB,wCAAwC;IACxC,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA,+EAA+E;AAC/E;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,oBAAoB;AACxB;;AAEA;;IAEI,mDAAmD;AACvD;;AAEA,+DAA+D;AAC/D;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,8BAA8B;IAC9B,sBAAsB;IACtB,+BAA+B;IAC/B,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,yDAAqY;IACrY,0BAA0B;IAC1B,gCAAgC;IAChC,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,yDAAqY;AACzY;;AAEA,4DAA4D;AAC5D;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,2CAA2C;IAC3C,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iDAAiD;AACrD;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,sBAAsB;IACtB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,8EAA8E;IAC9E,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;YACjB,iBAAiB;AAC7B","sourcesContent":["/* OpenSeadragon viewer styles. */\n\n/* Single canvas for tiled-level camera fields, composited above the OSD canvas */\n.morphle-tiled-fields-canvas {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 2;\n}\n\n/* Keep OSD control docks (navigator etc.) above overlays drawn inside the container */\n.openseadragon-container > div:not(.openseadragon-canvas) {\n    z-index: 100;\n}\n\n/* Navigator (minimap): top-right, below the toggle button. Offsets mirror NAVIGATOR_LAYOUT in viewerConfig.js. */\n.openseadragon-container .navigator {\n    /* Absolute so a width/height resize is not fought by OSD's relative dock layout */\n    position: absolute !important;\n    top: 60px !important;\n    right: 20px !important;\n    bottom: auto !important;\n    left: auto !important;\n    background-color: rgba(255, 255, 255, 0.55) !important;\n    border: 2px solid #333 !important;\n    border-radius: 6px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n    overflow: hidden !important;\n    box-sizing: border-box !important;\n}\n\n/* Seen-area heatmap, drawn inside the navigator under its display-region box */\n.osd-seen-area-canvas {\n    position: absolute;\n    left: 0;\n    top: 0;\n    pointer-events: none;\n}\n\n.openseadragon-container .navigator-scroll-handle,\n.openseadragon-container .displayregion {\n    border: 2px solid rgba(0, 128, 255, 0.5) !important;\n}\n\n/* Diagonal resize grip at the navigator's bottom-left corner */\n.osd-navigator-resize-handle {\n    position: absolute !important;\n    width: 14px !important;\n    height: 14px !important;\n    z-index: 10000 !important;\n    cursor: nesw-resize !important;\n    box-sizing: border-box;\n    pointer-events: auto !important;\n    border: none;\n    background-color: transparent;\n    box-shadow: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Cg stroke='%23333333' stroke-width='1.35' stroke-linecap='round'%3E%3Cline x1='2' y1='11' x2='5' y2='14'/%3E%3Cline x1='2' y1='7.5' x2='8.5' y2='14'/%3E%3Cline x1='2' y1='4' x2='12' y2='14'/%3E%3Cline x1='2' y1='0.5' x2='14' y2='12.5'/%3E%3C/g%3E%3C/svg%3E\");\n    background-size: 14px 14px;\n    background-position: left bottom;\n    background-repeat: no-repeat;\n    opacity: 0.75;\n}\n\n.osd-navigator-resize-handle:hover {\n    opacity: 1;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Cg stroke='%23111111' stroke-width='1.35' stroke-linecap='round'%3E%3Cline x1='2' y1='11' x2='5' y2='14'/%3E%3Cline x1='2' y1='7.5' x2='8.5' y2='14'/%3E%3Cline x1='2' y1='4' x2='12' y2='14'/%3E%3Cline x1='2' y1='0.5' x2='14' y2='12.5'/%3E%3C/g%3E%3C/svg%3E\");\n}\n\n/* Scale bar under the right-bottom controls (ScaleBarOSD) */\n.osd-scale-bar-pro {\n    pointer-events: none;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    background-color: rgba(255, 255, 255, 0.85);\n    padding: 8px 12px;\n    border-radius: 4px;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);\n    margin-top: 6px;\n    margin-right: 6px;\n}\n\n.osd-scale-bar-pro__ruler {\n    display: flex;\n    align-items: center;\n    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.4));\n}\n\n/* Width is set inline */\n.osd-scale-bar-pro__line {\n    height: 2px;\n    background-color: #333;\n    transition: width 0.15s ease-out;\n    min-width: 30px;\n}\n\n.osd-scale-bar-pro__cap {\n    width: 2px;\n    height: 10px;\n    background-color: #333;\n    border-radius: 1px 1px 0 0;\n}\n\n.osd-scale-bar-pro__label {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    font-size: 11px;\n    font-weight: 500;\n    letter-spacing: 0.02em;\n    color: #333;\n    padding-left: 2px;\n    -webkit-user-select: none;\n            user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
